import { render, staticRenderFns } from "./FormTemplateList.vue?vue&type=template&id=7582517b&"
import script from "./FormTemplateList.vue?vue&type=script&lang=js&"
export * from "./FormTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports